import React from "react";
import styled, { keyframes } from "styled-components";
import { Col, Row } from "react-bootstrap";
import { periodToComma } from "../../Helpers/CommonHelper";
import IconPath from "./../Elements/IconPath";

import {
  scaleInFigure,
  letterSpacingDruk,
  Inter
} from "../../Util/StyleProps";
import { device } from "../../Util/Breakpoints";
import { primaryColor } from "../../Util/Colors";

const Wrapper = styled.div`
  color: ${props => props.color};
  .MuiSvgIcon-root {
    background: #ffffff;
    border-radius: 50%;
  }
  .key-figure-wrapper{
  display: flex
  }
`;

const Span = styled.span`
  display: block;
  font-size: 16px;
  font-family: Inter;
  line-height: 24px;
  padding-left: 20px;
`;

const FigureWrapper = styled.div`
`;

const Figure = styled.p`
  font-weight: 700;
  padding-left: 20px;
  font-family: ${Inter};
  margin-top: 0;
  margin-bottom: 0;
  font-size: 36px;
  line-height: 42px;
  letter-spacing: -0.6px;
  first-child: nth-last-child(n + 3);
  animation: 2s ${props => (props.triggerAnimation ? scaleInFigure : "")} 0.5s
    cubic-bezier(0.175, 0.885, 0.275, 1.235);
  -webkit-animation: ${props => (props.triggerAnimation ? scaleInFigure : "")}
    0.5s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  animation-delay: ${props => props.delay}s;
  animation-fill-mode: both;
  white-space: nowrap;
    @media${device.tablet} {
    font-size: ${props => props.size || "48px"};
    line-height: 54px;
    letter-spacing: -0.7px;
  }
`;

const Icon = styled.div`
  background: #fff;
  border-radius: 50%;
  height: 72px;
  width: 72px;
`;

const SvgWrapper = styled.div`
  position: relative;
  height: 72px;
  width: 72px;
  text-align: center;
  line-height: 36px;

  & > svg {
    height: 40px;
    width: 40px;
    position: absolute;
    top: 50%;
    bottom: 50%;
    transform: translate(-50%, -50%);
  }
`;

const KeyFigureNew = props => {
  const {
    value,
    color,
    iconName,
    alt,
    triggerAnimation,
    delay,
    size,
    unit,
    subText,
    marginBottom = "40px"
  } = props;
  return (
    <Wrapper color={color}>
      <div className="key-figure-wrapper" style={{ marginBottom }}>
        <Icon>
          <SvgWrapper>
            <IconPath color={primaryColor} iconName={iconName} />
          </SvgWrapper>
        </Icon>
        <FigureWrapper>
          <Figure
            triggerAnimation={triggerAnimation}
            delay={delay}
          >
            {periodToComma(value)}
            {unit}
          </Figure>
          <Span>{subText}</Span>
        </FigureWrapper>
      </div>
    </Wrapper>
  );
};
KeyFigureNew.defaultProps = {
  iconName: "arrow-down",
  alt: "Ikon",
  marginBottom: "40px"
};

export default KeyFigureNew;
